/**
 * Created by Kamotin on 16.05.2017.
 */
var IndexService = (function () {

    var notificationDeliveryModal = $('#modalNotificationDelivery');

    function ecommercePromoClick(id, name, creative, position) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'ecommercePromoClick',
            'ecommerce': {
                'promoClick': {
                    'promotions': [
                        {
                            'id': id,
                            'name': name,
                            'creative': creative,
                            'position': position
                        }
                    ]
                }
            }
        });
    }

    function fillAllSiblings(parentId) {
        $.ajax({
            url: '/goods/checkSiblings/' + parentId,
            type: 'POST',
            contentType: 'application/json',
            success: function (response) {

                let items = $('.js-navbar-submenu-items');

                items.show();

                var sum = '';
                let example = $('.js-navbar-submenu-item-example');

                $.each(response, function (index, category) {

                    let element = example.clone();
                    element.removeClass("js-navbar-submenu-item-example");

                    element.css('display', 'inline-flex');

                    if (category.icon) {
                        element.find('.js-navbar-submenu-item-icon').attr('src', `/files/${category.icon}`);
                        element.find(".navbar-nav-item-submenu-category-item-icon").show();
                    }

                    element.find('.js-navbar-submenu-item-icon-href').attr('href', '/goods/' + category.path);
                    element.find('.js-navbar-submenu-item-title').attr('href', '/goods/' + category.path);
                    element.find('.js-navbar-submenu-item-title').text(category.title);
                    sum += element.prop('outerHTML');
                });
                items.html(sum);
            },
            error: function (response) {
            }
        })
    }

    function init() {

        $('.js-navbar-item').mouseover(
            function () {
                var element = $(this);
                var tail = element.find('.js-navbar-tail');
                var parentId = element.data('parentid');
                var isHaveSiblings = element.data('siblings');
                if (isHaveSiblings === true) {
                    tail.show();
                    $('.js-navbar-submenu').slideDown(200);
                    fillAllSiblings(parentId);
                    $('.js-navbar-submenu').mouseenter(
                        function () {
                            $('.js-navbar-tail').hide();
                            tail.show();
                        }
                    );
                } else {
                    /*var tail = $(this).find('.js-navbar-tail');
                    $('.js-navbar-submenu').slideUp(200);
                    tail.hide();*/
                }
            }
        );

        $(document).ready(function () {
            $.ajax({
                url: '/api/v6/account/bind/check/link',
                method: 'GET',
                contentType: 'application/json',
            })
                .done((response) => {
                    if (response.result.trim() == 'NEED BINDING') {
                        $('.modal.in').modal('hide');
                        $('#modalStartBindingAccounts').modal('show');
                    }
                });
        });

        $('.js-navbar-item').mouseout(
            function () {
                var tail = $(this).find('.js-navbar-tail');
                tail.hide();
                $('.js-navbar-submenu').mouseleave(
                    function () {
                        $('.js-navbar-submenu').slideUp(200);
                        tail.hide();
                    }
                );
            }
        );

        $('.js-category-item-link').click(function () {
            var id = $(this).data('id');
            var name = $(this).data('name');
            var creative = $(this).data('creative');
            var position = $(this).data('position');

            ecommercePromoClick(id, name, creative, position);
        });

        if (notificationDeliveryModal.length > 0) {
            var currentDate = new Date();
            var currentTimeInMinutes = currentDate.getHours() * 60 + currentDate.getMinutes();

            if (currentTimeInMinutes < window.workingTime.startInMinutes ||
                currentTimeInMinutes > window.workingTime.endInMinutes) {

                notificationDeliveryModal.modal('show');
            }
        }
    }

    return {
        init: init
    };
})();

$(IndexService.init);